let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bAoKR")).then(() => parcelRequire('6eH2E'));